import { render } from "./MdContentEditable.vue?vue&type=template&id=12ce67f8&scoped=true&ts=true"
import script from "./MdContentEditable.vue?vue&type=script&lang=ts"
export * from "./MdContentEditable.vue?vue&type=script&lang=ts"

import "./MdContentEditable.vue?vue&type=style&index=0&id=12ce67f8&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ce67f8"]])

export default __exports__